export default __webpack_public_path__ + "static/media/logo.e5e8c7d8.png";